import { Table } from '@tanstack/react-table'

import { MultiSelectCombobox } from '@/components/form-components/MultiSelectCombobox'

import { TemplateSummaryRow, WorkspaceDataTemplatesFilterOptions } from './workspaceDataTemplatesTableUtils'

type WorkspaceDataTemplatesFiltersProps = {
  table: Table<TemplateSummaryRow>
} & WorkspaceDataTemplatesFilterOptions

export function WorkspaceDataTemplatesFilters({
  table,
  entityTypeOptions,
  fileTemplateOptions,
  entityNameOptions,
}: WorkspaceDataTemplatesFiltersProps) {
  const selectedEntityTypes = ((table.getColumn('entityTypeName')?.getFilterValue() as string[] | undefined) ?? []).filter(
    Boolean
  )
  const selectedFileTemplates = (
    (table.getColumn('fileTemplateName')?.getFilterValue() as string[] | undefined) ?? []
  ).filter(Boolean)
  const selectedEntityNames = ((table.getColumn('entityName')?.getFilterValue() as string[] | undefined) ?? []).filter(
    Boolean
  )

  return (
    <>
      <div className="w-56">
        <MultiSelectCombobox
          triggerClassName="h-9"
          renderBadgesInTrigger
          options={entityTypeOptions}
          selectedValues={selectedEntityTypes}
          onSelectionChange={(values) =>
            table.getColumn('entityTypeName')?.setFilterValue(values.length > 0 ? values : undefined)
          }
          placeholder="By Entity Types"
          searchPlaceholder="Search entity types..."
          emptyMessage="No entity types found."
        />
      </div>
      <div className="w-56">
        <MultiSelectCombobox
          triggerClassName="h-9"
          renderBadgesInTrigger
          options={fileTemplateOptions}
          selectedValues={selectedFileTemplates}
          onSelectionChange={(values) =>
            table.getColumn('fileTemplateName')?.setFilterValue(values.length > 0 ? values : undefined)
          }
          placeholder="By File Templates"
          searchPlaceholder="Search file templates..."
          emptyMessage="No file templates found."
        />
      </div>
      <div className="w-56">
        <MultiSelectCombobox
          triggerClassName="h-9"
          renderBadgesInTrigger
          options={entityNameOptions}
          selectedValues={selectedEntityNames}
          onSelectionChange={(values) =>
            table.getColumn('entityName')?.setFilterValue(values.length > 0 ? values : undefined)
          }
          placeholder="By Entity Names"
          searchPlaceholder="Search entity names..."
          emptyMessage="No entity names found."
        />
      </div>
    </>
  )
}
